var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16.7188C17.0312 17.0312 17.0312 17.5 16.75 17.7812C16.4375 18.0938 15.9688 18.0938 15.6875 17.7812L12 14.0625L8.28125 17.7812C7.96875 18.0938 7.5 18.0938 7.21875 17.7812C6.90625 17.5 6.90625 17.0312 7.21875 16.7188L10.9375 13L7.21875 9.28125C6.90625 8.96875 6.90625 8.5 7.21875 8.21875C7.5 7.90625 7.96875 7.90625 8.25 8.21875L12 11.9688L15.7188 8.25C16 7.9375 16.4688 7.9375 16.75 8.25C17.0625 8.53125 17.0625 9 16.75 9.3125L13.0312 13L16.75 16.7188Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.fa77d12ec890e51279ed1f93c5da1cce.svg";
export { ForwardRef as ReactComponent };